export enum AccountEntryType {
  Credit,
  Debit,
}
